export default __webpack_public_path__ + "static/media/RhymesAnimalTales_09.fc3e7e39.png";